import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  getLocation() {
    if(!navigator.geolocation) {
    } else {
      document.getElementById('current-location').innerText = 'Meghatározás..';
      navigator.geolocation.getCurrentPosition(function(position) {
        window.Rails.ajax({
          url: "/users/update_location",
          type: "post",
          data: `lng=${position.coords.longitude}&lat=${position.coords.latitude}`,
          success: function(data) {
            location.reload();
          },
          error: function(data) {

          }
        })
      }, function(error){
        alert("Engedély megtagadva - geolokációs adatok lekérése sikertelen! Engedélyezéshez kérjük frissítse az oldalt!");
      });
    }
  }
}